import { getIsBrandPreview } from "@faire/retailer/lib/getIsBrandPreview";
import { isLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";

export const canShowVideoProducts = () =>
  getIsBrandPreview() || isLoggedInRetailer();
